module.exports = __webpack_public_path__ + "img/wap@2x.4037e6b1.png";